import { createContext, useContext, useState } from 'react';

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const [filterSelectedStateId, setFilterSelectedStateId] = useState('');
  const [filterSelectedLocationId, setFilterSelectedLocationId] = useState('');
  const [filterSelectedSiteId, setFilterSelectedSiteId] = useState('');
  const [searchText, setSearchText] = useState('');

  return (
    <FilterContext.Provider value={{
      filterSelectedStateId,
      setFilterSelectedStateId,
      filterSelectedLocationId,
      setFilterSelectedLocationId,
      filterSelectedSiteId,
      setFilterSelectedSiteId,
      searchText,
      setSearchText
    }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => useContext(FilterContext);
